// extracted by mini-css-extract-plugin
module.exports = {"a1cawpek":"a1cawpek","a47c4wn":"a47c4wn","bfzglju":"bfzglju"};